import React, { useContext } from "react"
import PropTypes from "prop-types"
import {Modal, Button, Form } from "react-bootstrap"
import { ModalContext } from "../layout"

function SubmitTicketModal({ onModalClose }) {
    const [showModal, setShowModal] = useContext(ModalContext)
    const handleClose = () => {
        onModalClose && onModalClose();
        setShowModal(false)
    }

    return (
        <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header>
                <Modal.Title>Submit a Ticket</Modal.Title>
            </Modal.Header>
            <Form name="Submit a Ticket Form" method="POST" action="/support#submit-a-ticket">
                <Modal.Body>
                    <input type="hidden" name="form-name" value="Submit a Ticket Form" />
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label netlify>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            placeholder="john@example.com"
                            required
                        />
                        <Form.Text className="text-muted">
                            <small>We'll never share your email with anyone else.</small>
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formFullName">
                        <Form.Label>Full name</Form.Label>
                        <Form.Control
                            type="text"
                            name="fullName"
                            placeholder="John Doe"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formDescription">
                        <Form.Label>Description</Form.Label>
                        <textarea
                            className="form-control"
                            name="description"
                            placeholder="Provide a precise description of your feedback"
                            rows="3"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formCompanyRole">
                        <Form.Label>Severity</Form.Label>
                        <select className="form-select"  name="severity">
                            <option selected style={{ color: '#808080'}}>Severity...</option>
                            <option value="Low">Low</option>
                            <option value="Moderate">Moderate</option>
                            <option value="High">High</option>
                        </select>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="px-4 mt-3"
                        variant="secondary"
                        style={{
                            borderRadius: "8px",
                        }}
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                    <Button
                        className="px-4 mt-3"
                        type="submit"
                        variant="primary"
                        style={{
                            background: "#1F7ABF",
                            borderRadius: "8px",
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

SubmitTicketModal.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
}

export default SubmitTicketModal
